<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel">Send Beach Report</h4>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="subject">Subject</label>
      <input type="text" class="form-control" id="subject" placeholder="Email Subject" [(ngModel)]="subjectText">
    </div>
    <div class="form-group">
      <label for="body">Body</label>
      <app-editor id="body" [(text)]="bodyText"></app-editor>
      <input type="checkbox" id="include_attachment" [(ngModel)]="include_attachment">
      <label for="include_attachment">Include report as attachment?</label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning"
            (click)="activeModal.close({subject: subjectText, body: bodyText, include_attachment: include_attachment})">Send
    </button>
    <button type="button" class="btn btn-primary" (click)="activeModal.dismiss()">Cancel</button>
  </div>
